var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	15208: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(3541).then(() => (() => (__webpack_require__(23541))))))),
	62702: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(2050).then(() => (() => (__webpack_require__(52050))))))),
	21011: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,30,3], () => (Promise.all([__webpack_require__.e(4395), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(84395))))))),
	13062: () => (loadStrictVersion("default", "react-i18next", false, [1,16,5,3], () => (__webpack_require__.e(8185).then(() => (() => (__webpack_require__(48185))))))),
	38493: () => (loadStrictVersion("default", "@hs-baumappe/web-auth", false, [1,4,7,0], () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(66384))))))),
	26523: () => (loadStrictVersion("default", "@hs-baumappe/redkit", false, [1,2,1,2], () => (Promise.all([__webpack_require__.e(6484), __webpack_require__.e(7366)]).then(() => (() => (__webpack_require__(66484))))))),
	53513: () => (loadStrictVersion("default", "@hs-baumappe/frontend-kit", false, [1,3,1,1], () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(29168))))))),
	35899: () => (loadStrictVersion("default", "@hs-baumappe/legacy-ui", false, [1,1,1,14], () => (Promise.all([__webpack_require__.e(4231), __webpack_require__.e(2702), __webpack_require__.e(4532)]).then(() => (() => (__webpack_require__(54231))))))),
	90585: () => (loadStrictVersion("default", "@apollo/client", false, [1,3,13,8], () => (Promise.all([__webpack_require__.e(1885), __webpack_require__.e(4036), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(64036))))))),
	60397: () => (loadStrictVersion("default", "@hs-baumappe/graphql-errors", false, [1,1,5,1], () => (Promise.all([__webpack_require__.e(9924), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(69924))))))),
	98650: () => (loadStrictVersion("default", "formik", false, [1,2,4,9], () => (__webpack_require__.e(2004).then(() => (() => (__webpack_require__(32004))))))),
	49427: () => (loadStrictVersion("default", "@hs-baumappe/forms", false, [1,5,2,4], () => (Promise.all([__webpack_require__.e(7000), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(47000))))))),
	12501: () => (loadStrictVersion("default", "launchdarkly-react-client-sdk", false, [1,3,9,0], () => (__webpack_require__.e(1631).then(() => (() => (__webpack_require__(31631))))))),
	99694: () => (loadStrictVersion("default", "@hs-baumappe/sap-credentials", false, [1,1,0,0], () => (__webpack_require__.e(675).then(() => (() => (__webpack_require__(50675))))))),
	38792: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(2156).then(() => (() => (__webpack_require__(72156))))))),
	42807: () => (loadStrictVersion("default", "yup", false, [4,0,32,11], () => (__webpack_require__.e(7206).then(() => (() => (__webpack_require__(77206))))))),
	41125: () => (loadStrictVersion("default", "i18next", false, [1,25,7,4], () => (__webpack_require__.e(4420).then(() => (() => (__webpack_require__(24420))))))),
	79789: () => (loadStrictVersion("default", "pretty-bytes", false, [1,6,1,1], () => (__webpack_require__.e(3684).then(() => (() => (__webpack_require__(81303))))))),
	3835: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(7757).then(() => (() => (__webpack_require__(37757))))))),
	64532: () => (loadStrictVersion("default", "@hs-baumappe/legacy-stylex", false, [1,1,0,3], () => (__webpack_require__.e(5454).then(() => (() => (__webpack_require__(75454))))))),
	98441: () => (loadSingletonVersion("default", "@hs-baumappe/llm-ui", false, [7,2,0,0,,"alpha",71], () => (Promise.all([__webpack_require__.e(5202), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(55202))))))),
	76378: () => (loadStrictVersion("default", "@hs-baumappe/rich-text-editor", false, [1,1,1,11], () => (Promise.all([__webpack_require__.e(4681), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(34681))))))),
	13939: () => (loadStrictVersion("default", "@hs-baumappe/pspdfkit", false, [1,1,6,0], () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(7294))))))),
	18521: () => (loadStrictVersion("default", "graphql", false, [1,16,12,0], () => (__webpack_require__.e(9322).then(() => (() => (__webpack_require__(46941))))))),
	27366: () => (loadStrictVersion("default", "@hs-baumappe/ui", false, [1,14,0,0], () => (Promise.all([__webpack_require__.e(9758), __webpack_require__.e(2702), __webpack_require__.e(7406)]).then(() => (() => (__webpack_require__(59758))))))),
	77406: () => (loadStrictVersion("default", "@hs-baumappe/stylex", false, [1,7,3,2], () => (__webpack_require__.e(904).then(() => (() => (__webpack_require__(90904)))))))
};
var initialConsumes = [15208,62702,21011,13062,38493,26523,53513,35899,90585,60397,98650,49427,12501,99694,38792,42807,41125,79789,3835,64532,98441,76378,13939,18521,27366];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"1125": [
		41125
	],
	"2431": [
		60397,
		21011
	],
	"2702": [
		62702
	],
	"3062": [
		13062
	],
	"4104": [
		98650,
		42807
	],
	"4532": [
		64532
	],
	"5208": [
		15208
	],
	"5899": [
		35899
	],
	"7366": [
		27366
	],
	"7406": [
		77406
	],
	"7637": [
		90585,
		38493
	],
	"8521": [
		18521
	],
	"8792": [
		15208,
		62702,
		21011,
		13062,
		38493,
		26523,
		53513,
		35899,
		90585,
		60397,
		98650,
		49427,
		12501,
		99694,
		38792,
		42807,
		41125,
		79789,
		3835,
		64532,
		98441,
		76378,
		13939,
		18521,
		27366
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}